'use strict';

const _ = require('lodash');
const jQuery = require('jquery');

const mediator = require('./../../core/mediator');
const container = require('./../../core/container');
const translator = require('./../../core/translator');

const ContentRepository = require('./repository/ContentRepository');
const DefinitionManager = require('./component/DefinitionManager');
const ContentManager = require('./component/ContentManager');

let events = {
  'global': {
    'application:ready': [
      {
        'callback': function() {
          ContentRepository.findDefinitions().done(function(definitions) {
            ContentRepository.findCategories().done(function() {
              DefinitionManager.add(definitions);

              mediator.publish('bundle:content:ready');
            });
          }).fail(function() {
            throw new Error('Error when retrieving definitions');
          });
        },
      },
      {'callback': require('./service/translateContent').init},
      {'callback': require('./repository/DesignRepository').getFonts},
    ],
    'request:send:fail': [
      {'callback': require('./listener/adsenseListener').onRequestFail},

    ],
    'after:content:remove': [
      {'callback': ContentManager.clearContentSet},
      {'callback': ContentManager.refreshResizeImage},
    ],
    'after:content:drop': [
      {'callback': require('./listener/imageListener').afterDrop},
      {'callback': require('./service/textPlaceholder').globalApply},
      {'callback': ContentManager.clearContentSet},
      {'callback': ContentManager.refreshResizeImage},
    ],
    'after:Text/Paragraph:submit:parameters': [
      {'callback': require('./listener/addContent').desktop.afterSubmitParameters.text},
    ],
    'menu:more-parameters:ready': [
      {
        'callback': function(items) {
          if (container.get('isAllowedTo')('BUNDLE_MEDIACENTER_FEATURE')) {
            if (require('./service/mediaLibrary').isEnabled()) {
              items.push({'name': 'media_library', 'pos': 4});
            }
          }
        },
      },
    ],
    'after:Article/ArticleTitle:submit:parameters': [
      {'callback': require('./listener/addContent').desktop.afterSubmitParameters.text},
    ],
    'after:Basic/Title:submit:parameters': [
      {'callback': require('./listener/addContent').desktop.afterSubmitParameters.text},
    ],
    'after:Article/ArticleAbstract:submit:parameters': [
      {'callback': require('./listener/addContent').desktop.afterSubmitParameters.text},
    ],
    'before:rte:config': [
      {'callback': require('./listener/rte').beforeConfig},
    ],
    'menu:more-parameters:media_library:click': [
      {'callback': require('./service/mediaLibrary').init},
    ],
    'before:plugin:upload:render': [
      {'callback': require('./service/mediaLibrary').beforeRenderUpload},
    ],
  },
  'desktop': {
    'menu:publish:click': [
      {'callback': require('./listener/publish').onPublish},
      {'callback': require('./../../services/structure/zone').hidePanels},
      {'callback': require('./../../services/overlay').show},
    ],
    'after:submit:parameters': [
      {'callback': require('./service/textPlaceholder').globalApply},
      {'callback': require('./listener/imageListener').afterSubmitParameters},
      {'callback': require('./plugin').onClick},
      {'callback': require('./service/translateContent').applyOnChange},
      {'callback': require('./plugin/ContentMenuParameter').afterSubmitParameters},
    ],
    'menu:cancel:click': [
      {'callback': require('./listener/publish').onCancel},
    ],
    'bundle:content:ready': [
      {'callback': require('./event/click').init},
      {'callback': require('./event/hover').init},
      {'callback': require('./service/dndZone').apply},
      {'callback': require('./service/resizeColumn').apply},
      {'callback': require('./listener/imageListener').initGlobalDndEvent},
      {'callback': require('./service/imagePlaceholder').init},
      {'callback': require('./plugin/ContentMenuParameter').init},
      {'callback': require('./service/textPlaceholder').globalApply},
      {
        'callback': function() {
          jQuery(window).publish('on:click');
        },
      },
      {'callback': require('./plugin/rte').initParameterRte},
    ],
    'before:popin:open': [
      {'callback': require('./plugin/remove').beforePopinOpen},
      {'callback': require('./plugin/rowSetting').beforePopinOpen},
      {'callback': require('./plugin/imagePlugins').beforePopinOpen},
    ],
    'on:plugin-content:build': [
      {'callback': require('./plugin/imagePlugins').onContentPluginBuild},
    ],
    'after:set:plugins:content': [
      {'callback': require('./plugin/imagePlugins').onContentHover},
    ],
    'on:rte:change': [
      {'callback': require('./plugin/rte').onRteChange},
    ],
    'before:rte:create': [
      {'callback': require('./service/dndZone').destroy},
      {'callback': require('./plugin/rte').beforeRteCreate},
    ],
    'after:rte:create': [
      {'callback': require('./plugin/rte').afterRteCreate},
    ],
    'before:rte:destroy': [
      {'callback': require('./service/dndZone').apply},
    ],
    'after:rte:destroy': [
      {'callback': require('./plugin/rte').afterRteDestroy},
    ],
    'after:content:refresh': [
      {'callback': require('./plugin/ContentMenuParameter').apply},
    ],
    'row-settings:click': [
      {'callback': require('./plugin/rowSetting').showForm},
    ],
    'on:row-settings:submit': [
      {'callback': require('./service/resizeColumn').apply},
      {'callback': require('./service/imagePlaceholder').init},
      {'callback': require('./service/textPlaceholder').globalApply},
      {'callback': require('./service/translateContent').init},
      {'callback': require('./service/dndZone').apply},
    ],
    'content:plugin:parameter': [
      {'callback': require('./plugin/parameter').showForm},
    ],
    'content:plugin:resize': [
      {'callback': require('./plugin/resize').onMousedown},
    ],
    'content:mouseover': [
      {'callback': require('./plugin').onMouseenter},
    ],
    'content:plugin:remove': [
      {'callback': require('./plugin/remove').remove},
    ],
    'content:plugin:plus': [
      {'callback': require('./plugin/plus').onClick},
    ],
    'content:add': [
      {'callback': require('./plugin/plus').onAdd},
    ],
    'on:dropdrop:block': [
      {'callback': require('./plugin/dnd').onDrop},
    ],
    'on:dragstart:block': [
      {'callback': require('./plugin/dnd').onDragStart},
    ],
    'on:dropover:block': [
      {'callback': require('./service/dndZone').onDropOver},
    ],
    'on:dropout:block': [
      {'callback': require('./service/dndZone').onDropOut},
    ],
    'on:dragstop:block': [
      {'callback': require('./plugin/dnd').onDragStop},
    ],
    'content:click': [
      {'callback': require('./service/imagePlaceholder').onContentClick},
    ],
    'content:force:click': [
      {'callback': require('./plugin').onClick},
    ],
    'content:mousedown': [
      {'callback': require('./plugin/rte').onMousedown},
    ],
    'content:mouseout': [
      {'callback': require('./plugin/imagePlugins').onContentMouseout},
      {'callback': require('./plugin').onMouseLeave},
    ],
    'on:click': [
      {'callback': require('./plugin').clearPluginsToolbar},
    ],
    'before:publish': [
      {'callback': require('./listener/publish').beforePublish},
    ],
    'after:parameters:shown': [
      {'callback': require('./plugin/parameter').afterParametersShown},
      {'callback': require('./plugin/ContentMenuParameter').afterParametersShown},
    ],
    'after:publish': [
      {'callback': require('./listener/publish').afterPublish},
    ],
    'after:Text/Paragraph:add': [
      {'callback': require('./listener/addContent').desktop.after.text},
    ],
    'after:Basic/Searchbar:add': [
      {'callback': require('./listener/addContent').desktop.after.noAction},
    ],
    'after:Article/ArticleTitle:add': [
      {'callback': require('./listener/addContent').desktop.after.text},
    ],
    'after:Article/ArticleAbstract:add': [
      {'callback': require('./listener/addContent').desktop.after.text},
    ],
    'after:upload': [
      {'callback': require('./plugin').onClick},
      {'callback': require('./listener/imageListener').afterUpload},
    ],
    'window:resize': [
      {'callback': require('./service/dndZone').apply},
    ],
    'before:content:add': [
      {'callback': require('./listener/addContent').desktop.before.basic},
      {'callback': require('./plugin').clearPluginsToolbar},
    ],
    'after:content:add': [
      {'callback': require('./service/textPlaceholder').globalApply},
      {'callback': require('./listener/imageListener').afterAdd},
      {'callback': ContentManager.refreshResizeImage},
      {'callback': require('./listener/addContent').desktop.after.basic},
      {'callback': require('./service/translateContent').applyOnChange},
    ],
    'ui-enabled': [
      {'callback': require('./service/dndZone').enable},
      {'callback': require('./service/resizeColumn').enable},
      {'callback': require('./plugin/ContentMenuParameter').init},
    ],
    'ui-disabled': [
      {'callback': require('./service/dndZone').disable},
      {'callback': require('./service/resizeColumn').disable},
      {'callback': require('./plugin/ContentMenuParameter').destroy},
    ],
    'flash-callback:remain-publish': [
      {
        'callback': function() {
          mediator.subscribe('after:menu:show', function() {
            setTimeout(function() {
              require('./listener/publish').createRemainingPopover();
            }, 200);
          }, true);
        },
      },
    ],
    'flash-callback:remain-publish-only-onther-pages': [
      {
        'callback': function() {
          mediator.subscribe('after:menu:show', function() {
            setTimeout(function() {
              require('./listener/publish').createRemainingPopover(true);
            }, 200);
          }, true);
        },
      },
    ],
    'flash-callback:canceled-page': [
      {'callback': require('./listener/publish').onCanceledPageFlashCallback},
    ],
    'before:show:parameters': [
      {
        'callback': (object) => {
          if (object.type === 'Basic/Menu') {
            object.submitText = 'save';
          }
        },
      },
    ],
  },
  'mobile': {
    'menu:publish:click': [
      {'callback': require('./listener/publish').onPublish},
      {'callback': require('./../../services/structure/zone').hidePanels},
    ],
    'menu:ready': [
      {
        'callback': function(add) {
          add(translator.translate('add_content'), 'plus', 40, 'add-content', 'btn-add-content', undefined, undefined, 'secondary');
        },
      },
    ],
    'menu:cancel:click': [
      {'callback': require('./mobile/publish').onCancel},
    ],
    'menu:close:after': [
      {'callback': require('./mobile/plugins').removeHighlight},
    ],
    'menu:add-content:click': [
      {'callback': require('./mobile/plus').onClick},
    ],
    'after:submit:parameters': [
      {'callback': require('./service/editIframe').build},
      {'callback': require('./service/translateContent').applyOnChange},
    ],
    'content:add': [
      {'callback': require('./mobile/plus').onAdd},
      {'callback': require('./service/editIframe').build},
    ],
    'bundle:content:ready': [
      {'callback': require('./mobile/plugins').init},
      {'callback': require('./service/imagePlaceholder').init},
      {'callback': require('./service/textPlaceholder').globalApply},
      {'callback': require('./service/editIframe').build},
    ],
    'before:upload': [
      {'callback': require('./mobile/upload').beforeUpload},
    ],
    'after:upload': [
      {'callback': require('./listener/imageListener').afterUpload},
    ],
    'layer:close': [
      {'callback': require('./mobile/parameters').onLayerClose},
    ],
    'panels:close': [
      {'callback': require('./mobile/parameters').onLayerClose},
    ],
    'plugins:menu': [
      {'callback': require('./mobile/pluginsMenu').onMenu},
    ],
    'menu:delete-content:click': [
      {'callback': require('./mobile/delete').onClick},
    ],
    'menu:configure-content:click': [
      {'callback': require('./mobile/parameters').onClick},
    ],
    'before:render:menu-item': [
      {'callback': require('./mobile/upload').beforeRenderMenuItem},
    ],
    'menu:move-content:click': [
      {'callback': require('./mobile/move').onClick},
    ],
    'before:publish': [
      {'callback': require('./../../services/structure/menu/mobile').close},
      {'callback': require('./../../services/overlay').show},
      {'callback': require('./../../services/loader').start},
    ],
    'after:publish': [
      {'callback': require('./../../services/overlay').hide},
      {'callback': require('./../../services/loader').stop},
    ],
    'menu:rte-content:click': [
      {'callback': require('./mobile/rte').onPressEdit},
    ],
    'before:Text/Paragraph:add': [
      {'callback': require('./listener/addContent').mobile.before.hidePanels},
    ],
    'after:Text/Paragraph:add': [
      {'callback': require('./listener/addContent').mobile.after.showMenu},
    ],
    'after:Article/ArticleTitle:add': [
      {'callback': require('./listener/addContent').mobile.after.showMenu},
    ],
    'after:Article/ArticleAbstract:add': [
      {'callback': require('./listener/addContent').mobile.after.showMenu},
    ],
    'zone:show:before': [
      {'callback': require('./mobile/plugins').removeHighlight},
      {'callback': require('./listener/dropback').close},
    ],
    'after:rte:create': [
      {'callback': require('./mobile/rte').afterRteCreate},
    ],
    'before:rte:destroy': [
      {'callback': require('./mobile/rte').beforeRteDestroy},
    ],
    'after:rte:destroy': [
      {'callback': require('./mobile/rte').afterRteDestroy},
    ],
    'before:content:add': [
      {'callback': require('./listener/imageListener').beforeMobileAdd},
      {'callback': require('./listener/addContent').mobile.before.basic},
    ],
    'after:content:drop': [
      {'callback': require('./listener/imageListener').afterMobileDrop},
    ],
    'after:content:add': [
      {'callback': require('./listener/imageListener').afterMobileAdd},
      {'callback': require('./service/textPlaceholder').globalApply},
      {'callback': ContentManager.refreshResizeImage},
      {'callback': require('./listener/addContent').mobile.after.basic},
      {'callback': require('./service/translateContent').applyOnChange},
    ],
  },
};

module.exports = {
  'settings': {
    'contents_not_editable': [
      'ContentSet',
      'Element/Text',
      'Element/Image',
      'Element/File',
      'CloudContentSet',
      'ColContentSet',
    ],
  },
  'events': _.merge(events.global, events[container.get('isMobile') ? 'mobile' : 'desktop']),
};
